import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import SignaturePad from 'react-signature-pad-wrapper'
import {

  WAREHOUSES_BASE_URL,


} from '../config';
import axios from 'axios';


// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import ClubHeader from './ClubHeader';



// Hook
import useAuth from '../hooks/useAuth';

import { useWarehouseFetch } from '../hooks/useWarehouseFetch';
// Image

import Grid from './Grid';
import Display from './Display';
import PdfComp from './PdfComp';
import Sidepanel from './SidePanel';




const Warehouse = () => {



  const auth = useAuth();
  const { id } = useParams()
  const location = useLocation();
  console.log(id)
  const { state, loading, error, setLoading, setTrigger } = useWarehouseFetch(id);
  const [pdffile, setPdfFile] = useState(null)
  const [edit, setEdit] = useState(false)
  const from = location.state?.from || "./";
console.log("from = "+from)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [contractsOpen, setContractsOpen] = useState(false)
  const [idOpen, setIdOpen] = useState(false)
  const [otherOpen, setOtherOpen] = useState(false)

  const form = useForm()
  const { register, control, handleSubmit, formState } = form
  const { errors } = formState
  const [errMessage, setErrMessage] = useState("");
  const username = auth.auth.user.username
  const access = auth.auth.user.userRole
  const accessToken = auth.auth.accessToken
  // console.log(besluit.besluit[0].besluit)
  console.log(state)
  console.log(location.state)



  const handleEdit = () => {
    setEdit((prev) => !prev)
  }
  const onSubmit = async (data) => {

    console.log(data)
    console.log(accessToken)

    const transformedData = {
      ...data,

      EEA1: {
        disability: data.EEA1.disability === "" ? false : data.EEA1.disability,
        foreignNational: data.EEA1.foreignNational === "" ? false : data.EEA1.foreignNational,
        gender: data.EEA1.gender,
        race: data.EEA1.race

      }
      // sdate: data.sdate
      //   ? new Date(data.sdate).toLocaleDateString('en-US', {
      //       year: 'numeric',
      //       month: 'long',
      //       day: 'numeric',
      //     })
      //   : null,
      // termdate: data.termdate
      //   ? new Date(data.termdate).toLocaleDateString('en-US', {
      //       year: 'numeric',
      //       month: 'long',
      //       day: 'numeric',
      //     })
      //   : null,

    };

    console.log(transformedData)

    try {
      const response = await axios.patch(`${WAREHOUSES_BASE_URL}/${id}`,
        JSON.stringify({ data: data }),
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + accessToken

          }
        }
      );


      console.log(response)
      setEdit(false)
      setErrMessage("")
      setTrigger(true)

    } catch (error) {

      if (!error.response) {
        setErrMessage("No server response")
      } else if (error.response?.status === 400) {
        setErrMessage("Missing data")
      } else if (error.status === 500) {
        console.log(error.message)
        setErrMessage(error.message + " " + error.response?.data?.msg?.message)
      } else {
        setErrMessage('failed')
      }
      console.log(error)
    }






  }

  return (
    <>

      <Header username={username} role={access} destination={from}></Header>
      <div className='stockBody'>

        <Grid
          header={`${state.name}`}

        >

          {!edit ?
            (<>
              <Knoppie
                text={"Edit profile"}
                callback={handleEdit}
              ></Knoppie>

              <div>
                <div className='Lineitem'>
                  <div>Name:</div><div>{state.name}</div>
                </div>
               
              </div>

              <div>Stock on Hand:</div>

              {state.stockitems?.length>0 ?
              (state.stockitems?.map((item)=>(
                <>
                <div>{item.stockitem.desc}</div>
                 <div>{item.stockonhand}</div> 
              </>
              ))):
              (<div>This warehouse is empty</div>)
            }




              {/* key={state._id}
                employee={state.employee}
                group={state.group}

                dept={state.dept}
                title={state.title}

                givname={state.givname}
                surname={state.surname}
                adr1={state.adr1}
                adr2={state.adr2}
                adr3={state.adr3}
                pcode={state.pcode}
                phone={state.phone}
                sdate={state.sdate}
                baserate={state.baserate}
                holrule={state.holrule}
                sicrule={state.sicrule}
                holavail={state.holavail}
                leaveDates={""}
                termdate={state.termdate}
                position={state.position}
                identity={state.identity}
                incometax={state.incometax}
                dob={state.dob}
                active={state.active}
                normalHours={state.normalHours}
                gender={state.EEA1?.gender}
                race={state.EEA1?.race}
                disability={state.EEA1?.disability?.toString()}
                foreignNational={state.EEA1?.foreignNational?.toString()}
                injuryOnDuty={state.injuryOnDuty}
                IDOnFile={state.IDOnFile}
                emailaddress={state.emailaddress}

                id={state._id}
                edit={edit} */}


            </>
            )
            :
            (<>
              <Knoppie
                text={"Cancel"}
                callback={handleEdit}
              ></Knoppie>





              {errMessage !== "" ? <div>{errMessage}</div> : ""}

              <form onSubmit={handleSubmit(onSubmit)}>
                <button>Submit</button>

                <div className='Lineitem'>
                  <label>Employee Code</label>
                  <input className="inputsize" type={"text"} defaultValue={state.employee}{...register('employee', {
                    required: 'employee code is required'
                  })} />
                </div>
                {errors.employee ? <p className='error'>{errors.employee?.message}</p> : ""}
                <div className='Lineitem'>
                  <label>Employee name</label>
                  <input className="inputsize" type={"text"} defaultValue={state.givname} {...register('givname', {
                    required: 'name is required'
                  })} />
                </div>
                {errors.givname ? <p className='error'>{errors.employee?.givname}</p> : ""}
                <div className='Lineitem'>
                  <label>Employee surname</label>
                  <input className="inputsize" type={"text"} defaultValue={state.surname}{...register('surname', {
                    required: 'surname is required'
                  })} />
                </div>
                {errors.surname ? <p className='error'>{errors.surname?.message}</p> : ""}
                <div className='Lineitem'>
                  <label>Employee group</label>
                  <input className="inputsize" type={"text"} defaultValue={state.group}{...register('group')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee dept</label>
                  <input className="inputsize" type={"text"} defaultValue={state.dept} {...register('dept')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee title</label>
                  <input className="inputsize" type={"text"} defaultValue={state.title}{...register('title')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee adr1</label>
                  <input className="inputsize" type={"text"} defaultValue={state.adr1}{...register('adr1')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee adr2</label>
                  <input className="inputsize" type={"text"} defaultValue={state.adr2}{...register('adr2')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee adr3</label>
                  <input className="inputsize" type={"text"} defaultValue={state.adr3}{...register('adr3')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee pcode</label>
                  <input className="inputsize" type={"text"} defaultValue={state.pcode}{...register('pcode')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee phone</label>
                  <input className="inputsize" type={"number"} defaultValue={state.phone}{...register('phone')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee sdate</label>
                  <input className="inputsize" type={"date"} defaultValue={state.sdate}{...register('sdate')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee baserate</label>
                  <input className="inputsize" type={"text"} defaultValue={state.baserate}{...register('baserate')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee holrule</label>
                  <input className="inputsize" type={"text"} defaultValue={state.holrule}{...register('holrule')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee sicrule</label>
                  <input className="inputsize" type={"text"} defaultValue={state.sicrule}{...register('sicrule')} />

                </div>

                <div className='Lineitem'>
                  <label>Employee termdate</label>
                  <input className="inputsize" type={"date"} defaultValue={state.termdate}{...register('termdate')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee position</label>
                  <input className="inputsize" type={"text"} defaultValue={state.position}{...register('position')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee identity</label>
                  <input className="inputsize" type={"id"} defaultValue={state.identity}{...register('identity')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee incometax</label>
                  <input className="inputsize" type={"text"} defaultValue={state.incometax}{...register('incometax')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee dob</label>
                  <input className="inputsize" type={"text"} defaultValue={state.dob}{...register('dob')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee active</label>
                  <input className="inputsize" type={"text"} value="true" {...register('active')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee gender</label>
                  <input className="inputsize" type={"text"} defaultValue={state.EEA1?.gender}{...register('EEA1.gender')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee race</label>
                  <input className="inputsize" type={"text"} defaultValue={state.EEA1?.race}{...register('EEA1.race')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee disability</label>
                  <label>
                    Marked if true
                    <input
                      className="inputsize"
                      type="checkbox"
                      defaultChecked={state.EEA1?.disability || false}
                      {...register('EEA1.disability')} />
                  </label>
                </div>
                <div className='Lineitem'>
                  <label>Employee foreignNational</label>
                  <label>
                    Marked if true
                    <input
                      className="inputsize"
                      type="checkbox"
                      defaultChecked={state.EEA1?.foreignNational || false}
                      {...register('EEA1.foreignNational')} />

                  </label>
                </div>
                <div className='Lineitem'>
                  <label>Employee emailaddress</label>
                  <input className="inputsize" type={"text"} defaultValue={state.emailaddress}{...register('emailaddress', {
                    pattern: {
                      value: /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm,
                      message: "email validation failed"
                    }
                  })} />

                </div>
              </form>
            </>
            )

          }





        </Grid>
      </div >


    </>
  );
};

export default Warehouse;

